// Return destinations are dashboard routes, never arbitrary URLs or server endpoints.
export function safeReturnTo(value, router) {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//")) {
    return null;
  }
  // Google carries this in the cookie session; leave room for the session itself.
  if (new TextEncoder().encode(value).length > 2048) return null;

  // Reject encoded controls/backslashes as well as their literal forms. Decode only
  // for validation; retain the original query and hash for the actual navigation.
  let decoded = value;
  try {
    while (true) {
      if (!decoded.startsWith("/") || decoded.startsWith("//") || /[\\\u0000-\u001f\u007f]/.test(decoded)) {
        return null;
      }
      const next = decoded.replace(/%([0-9a-f]{2})/gi, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
      if (next === decoded) break;
      decoded = next;
    }

    const target = router.resolve(value);
    if (["not-found", "account-setup"].includes(target.name) ||
        !target.matched.some((record) => record.meta.requiresAuth)) {
      return null;
    }
    return target.fullPath;
  } catch {
    return null;
  }
}

export function returnToQuery(value, router) {
  const path = safeReturnTo(value, router);
  return path ? { return_to: path } : {};
}

export function afterLoginLocation(value, router) {
  return safeReturnTo(value, router) || { name: "dashboard" };
}
